import axios from "axios"
import {fetchUserDetails} from "./fetchStore"
import {getToken} from "./helper"
import { updateAuthenticationStore, updateMonetizationStore } from "./updateStore"
import pubsub from "@viewlift/pubsub"
import { fetchUserData, getPreferredLanguage, handleUserTransactions, pushToDatalayer } from "../../../helpers"
import { publishRedirect, publishRedirectWithOptions} from "../../../OnBoarding-V2/Events/utils.events"
import { parseJSON } from './helper'
import { dynamicConfig } from "../../../components/DynamicRoutes"
import logger from "../../../logger";
import { getStorageItem, setStorageItem } from "../../../helpers/storageManager"
let xApikey = window?.xApiKey
let apiBaseUrl = window?.app_data?.appcmsMain?.apiConfig?.apiBaseUrl;
let site = window?.app_data?.site?.siteInternalName
let countryCode = window?.app_data?.countryCode || "IN"

export const getSubscriptionPlans =  async() => {
  try {
    let token = await getToken(token => {return token})
    let { userId, mvpdProvider } = await fetchUserDetails()
    let params = {
      site : site,
      device : "web_browser",
      monetizationModel : "SVOD",
      platform : "web_browser"
    }
    if(userId) params.userId = userId
    if(mvpdProvider) params.mvpdProvider = mvpdProvider
      let res = await axios.get(`${apiBaseUrl}/v3/plans`,
      {
        params,
        headers: {
          'x-api-key': xApikey,
          authorization : token
        }
      })
      return res.data
  } catch(e) {
    pubsub.publish('isLoading', false)
  }
  }
  export var getDiscountPrice = async (data) => {
    let token = await getToken(token => {return token})
    let redirected = getStorageItem("isRedirected")
    let transactionData = getStorageItem('transactionData') 
    let transactionType = transactionData?.purchaseType === "Buy" ? "PURCHASE" : transactionData?.purchaseType?.toUpperCase()
    let splashPromoCode = parseJSON(sessionStorage.getItem('promoCode'))
    let params = {
      countryCode: countryCode,
      planId: data?.id,
      site: site,
      offerCode: splashPromoCode?.promoCode || data?.offerCode || null,
      transactionType: data?.transactionType || transactionType
    }
    if (redirected?.isUpgradePlan) {
      params.actionType = "upgrade"
    }
          return axios ({
            method: 'GET',
            url: `${apiBaseUrl}/subscription/calculate/discount`,
            params: params,
            headers: {
              Authorization: token,
              'x-api-key': xApikey
            }
          }).catch(()=> {
            pubsub.publish('isLoading', false)
          })
  }

  export const getPlansByUserId = async () => {
    try {
      pubsub.publish('isLoading', true)
      let token = await getToken(token => token)
      let { userId } = await fetchUserDetails()
      if (!userId) {
        return null
      }
      let params = {
        site : site,
        userId : userId,
        device : "web_browser",
        monetizationModel : "SVOD",
        platform : "web_browser"
      }
      const response = await axios({
        method: 'GET',
        url: `${apiBaseUrl}/v3/plans`,
        params: params,
        headers: { 
          Authorization: token,
          'x-api-key': xApikey
        }
      })
      return response.data
    } catch (error) {
      pubsub.publish('isLoading', false)
    } finally {
      pubsub.publish('isLoading', false)
    }
  }

  export const validateSubscriptionOfferCodeByPlanId = async (payload) => {
    try {
      let token = await getToken(token => {return token})
      const response = await axios({
        method: 'POST',
        url: `${apiBaseUrl}/subscription/offer/validate`,
        params: { site: site },
        data: payload,
        headers: { 
          Authorization: token,
          'x-api-key': xApikey
        }
      })
      return {
        isError: false,
        data: response.data
      }
    } catch (error) {
      return {
        isError: true,
        code:(error.response && error.response.data && error.response.data.code),
        error: (error.response && error.response.data && error.response.data.message) || 'An error occuredd. Try again later'
      }
    }
  }

  export const getSubscriptionMetadata = async (paylaod) => {

    let token = await getToken(token => {return token})
    var contentApiHeaders = {
      Authorization: token,
      'x-api-key': xApikey,
    }
    const response = await axios({
      method: "GET",
      url: `${apiBaseUrl}/content/pages?path=/subscription&languageCode=${getPreferredLanguage()}&includeContent=true&countryCode=IN&site=${site}`,
      headers: contentApiHeaders
    })
    return response && response.data && response.data.modules && response.data.modules[0].metadataMap
  }

  export const getAddress = (value) => {
    return axios.get(`https://maps.googleapis.com/maps/api/geocode/json?components=postal_code:${value}&key=AIzaSyCjULGl-zqfHzWOrRwHpanj3q7uXHM4OPY`)
    .then( response =>{
      if(response.data.results.length > 0){
        const results = response.data.results[0]
        let address = {
          country: results['address_components'].find(item => item.types.includes('country'))?.['short_name'],
          state: results['address_components'].find(item => item.types.includes('administrative_area_level_1'))?.['short_name'],
          city: results['address_components'].find(item => item.types.includes('locality') || item.types.includes('postal_town'))?.['short_name']
      };
        return address
      }
    })
  }

  export const subscriptionData = async () => {
    try {
      let token = await getToken(token => {return token})
      let { userId } = await fetchUserDetails()
        return axios({
          method: 'GET',
          url: `${ apiBaseUrl }/v3/subscription/user`,
          params: { site: site, userId: userId },
          headers: { 
            Authorization:token,   
            'x-api-key': xApikey
          }
        }).then(async (res) => {
          // removing extra calls and handling sub-info
          let subscriptionStatus = res?.data?.subscriptionInfo?.subscriptionStatus
          let isSubscribed = ((subscriptionStatus === 'COMPLETED') || (subscriptionStatus === "DEFERRED_CANCELLATION")) ? true : false
          const store = getStorageItem('AuthenticationStore');
          setStorageItem('AuthenticationStore',{user: {...store?.user,subscription : {...res.data,subscriptionStatus : res?.data?.subscriptionInfo?.subscriptionStatus},isSubscribed}})
          pubsub.publish("update-user-state",true)
          pubsub.publish('billing-loader', true)
          return res?.data
      }).catch((e) => {
        console.log(e)
      })
    } 
    catch(e) {
    pubsub.publish('isLoading', false)
    pubsub.publish('processing',false)
    }
  }

const pushToNextRoute = async () => {
  let isSkipped = false
  let nextRoute = await dynamicConfig(null,location?.pathname,isSkipped)
  return nextRoute
}
  export const subscriptionStore = async (handleRoute,navigateRef,isCheckout,subData) => {
    try {
        let res = subData ? subData : await subscriptionData()
        if(res?.subscriptionInfo?.paymentUniqueId) {
          pushToDatalayer('transaction_completed', res?.subscriptionInfo?.paymentUniqueId);
        }
        updateMonetizationStore(null,null,null,res)
        pubsub.publish('processing',false)
        let redirected = getStorageItem("isRedirected") 
        if (isCheckout) {
          if( !redirected?.redirect && redirected?.isDetailPage){
            // pubsub.publish("showCheckoutDetailPage", null)
            publishRedirectWithOptions({
              path:location.href,
              options:{
                replace:true
              }
            })
            return
          }
          let nextRoute = pushToNextRoute()
          nextRoute.then((res) => {
            pubsub.publish('isLoading', false)
            setTimeout(()=> {
              logger(res)
              publishRedirect(res)
            },200)
          })
        }
        if (redirected?.isUpgradePlan) {
          pubsub.publish('processing',false)
          pubsub.publish('apploading', false);
          navigateRef.current(redirected?.path)
          return
        }
        let justSubscribed = true
        let nextRoute = handleRoute(justSubscribed)
        nextRoute.then((res) => {
          pubsub.publish('isLoading', false)
          setTimeout(()=> {
            if(redirected?.contentSubscriptionFlow?.enabled) {
              setStorageItem("isRedirected", { ...redirected, contentSubscriptionFlow : {...redirected.contentSubscriptionFlow, enabled : false}, path : location.pathname})
              navigateRef.current(redirected?.path);
            }else {
              navigateRef.current(res);
            }
          },200)
        })
    }
    catch(e) {
      pubsub.publish('isLoading', false)
      pubsub.publish('processing',false)
    }
  }
  export const purchaseStore = async (handleRoute,navigateRef, isCheckout = false) => {
      handleUserTransactions()
      if (isCheckout) {
        let redirected = getStorageItem("isRedirected");
        if( !redirected?.redirect && redirected?.isDetailPage){
          publishRedirectWithOptions({
            path: window.location.href,
            options:{
              replace:true
            }
          })
          return
        }
        let nextRoute = pushToNextRoute()
        nextRoute.then((res) => {
          pubsub.publish('isLoading', false)
          setTimeout(()=> {
            logger(res)
            publishRedirect(res)
          },200)
        })
        return;
      }
      let nextRoute = handleRoute()
      pubsub.publish('processing',false)
      pubsub.publish('isLoading', false)
      nextRoute.then((res) => {
        setTimeout(()=> {
          navigateRef.current(res);
        },200)
      })
  }